<template>
  <div class="secure-payment-container">
    <h2>Your payments are protected</h2>
    <div class="secure-payment-info">
      <ul class="secure-payment-images">
        <li v-for="method in securePaymentMethods" :key="method.name" class="payment-image">
          <img :src="method.logo" :alt="method.name" />
        </li>
      </ul>
      <p class="secure-payment-text">
        Every transaction is secured with advanced measures that encrypt cardholder
        data and ensure its proper handling and protection
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import mastercardIdCheckLogo from '@/assets/protected-methods/mastercardIdCheckLogo.png'
import pciDssLogo from '@/assets/protected-methods/pciDssLogo.png'
import sslLogo from '@/assets/protected-methods/sslLogo.png'
import threeDSecureLogo from '@/assets/protected-methods/threeDSecureLogo.png'
import visaSecureLogo from '@/assets/protected-methods/visaSecureLogo.png'

const securePaymentMethods = [
  { name: 'PCI DSS Compliant', logo: pciDssLogo },
  { name: '3D Secure', logo: threeDSecureLogo },
  { name: 'SSL Encrypted', logo: sslLogo },
  { name: 'Visa Secure', logo: visaSecureLogo },
  { name: 'Mastercard ID Check', logo: mastercardIdCheckLogo },
]
</script>

<style scoped lang="scss">
.secure-payment-images {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 8px;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 60px;
    height: 60px;
  }
}

.secure-payment-text {
  text-align: center;
  color: #525252;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
</style>
